// 引入element日文语言
import eleJa from 'element-ui/lib/locale/lang/ja'
import iviewJa from 'view-design/dist/locale/ja-JP'
import index from '@/views/index/locales/ja' // 结算报表模块
import settlement from '@/views/settlement/locales/ja' // 结算报表模块
// import dataReport from '@/views/dataReport/locales/ja' // 交易分析模块
import tradeEchart from '@/views/transactionAnalysis/locales/ja' // 交易分析模块
import paymentRecord from '@/views/paymentRecord/locales/ja' // 自动提现模块
import fundManagement from '@/views/fundManagement/locales/ja' // 提现模块
import components from '@/components/locales/ja' // compontnts文件夹中的公共组件
import webList from '@/views/websiteCenter/locales/ja' // 网站管理
import login from '@/views/login/locales/ja' // 登录注册
import home from '@/views/exhibition/locales/ja' // 登录注册
import account from '@/views/accountCenter/locales/ja' // 账号中心
import chargeBack from '@/views/riskManagement/chargeback/locales/ja' // 拒单
import certification from '@/views/certification/locales/ja' // 实名认证
import cashAccount from '@/views/cashAccount/locales/ja' // 提现账户
import logistics from '@/views/logisticsManage/locales/ja' // 物流管理
import riskTranscation from '@/views/riskManagement/riskTransactionManagement/locales/ja' // 风险订单
import system from '@/views/system/locales/ja' // 权限管理
import withdrawModule from '@/views/withdrawModule/locales/ja' // 提现模块
import homePage from '@/views/homePage/locales/ja' // 首页
import messageReceiverSetting from '@/views/messageReceiverSetting/locales/ja' // 首页
import blackList from '@/views/riskManagement/blackList/locales/ja' // 黑名单
import whiteList from '@/views/riskManagement/whiteList/locales/ja' // 白名单
import selectWebsite from '@/views/ppAuthorization/locales/ja'
import tradeType from '@/views/trade-type/locales/ja'
import paymentLink from '@/views/paymentLink/locales/ja'
import checkoutCustomSettings from '@/views/checkoutCustomSettings/locales/ja'
import messageCenter from '@/views/messageCenter/locales/ja' // 消息中心
import disputeManage from '@/views/riskManagement/disputeManage/locales/ja' // 争议订单管理
import offlineKyc from '@/views/offlineKyc/locales/ja' // 线下KYC
import storeManage from '@/views/storeManage/locales/ja'
import landing from '@/views/landing/locales/ja' // 官网

const ja = {
	...eleJa,
	...iviewJa,
	index,
	settlement,
	// dataReport,
	tradeEchart,
	paymentRecord,
	certification,
	fundManagement,
	components,
	chargeBack,
	webList,
	account,
	login,
	home,
	logistics,
	withdrawModule,
	cashAccount,
	riskTranscation,
	homePage,
	system,
	messageReceiverSetting,
	blackList,
	whiteList,
	selectWebsite,
	tradeType,
	paymentLink,
	checkoutCustomSettings,
	messageCenter,
	disputeManage,
	offlineKyc,
	storeManage,
	landing
}

export default ja
